import React from 'react';
import { Helmet } from 'react-helmet';
import { getSeoForPath, NOT_FOUND_SEO, SITE_NAME, notFoundCanonical } from '../../../content/seoMeta';

/**
 * Unique title, description, canonical, Open Graph, and Twitter tags.
 * Uses react-helmet already in the CRA app — no SSR rewrite.
 */
export default function PageMeta({ path }) {
  const seo = getSeoForPath(path);

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={seo.canonical} />

      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={seo.canonical} />
      <meta property="og:type" content={seo.ogType} />
      <meta property="og:image" content={seo.ogImage} />
      <meta property="og:site_name" content={seo.siteName} />

      <meta name="twitter:card" content={seo.twitterCard} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.ogImage} />
    </Helmet>
  );
}

/** Unknown routes: noindex, and a canonical that is not the homepage. */
export function NotFoundMeta({ pathname }) {
  const canonical = notFoundCanonical(pathname);

  return (
    <Helmet>
      <title>{NOT_FOUND_SEO.title}</title>
      <meta name="description" content={NOT_FOUND_SEO.description} />
      <meta name="robots" content={NOT_FOUND_SEO.robots} />
      {canonical ? <link rel="canonical" href={canonical} /> : null}

      <meta property="og:title" content={NOT_FOUND_SEO.title} />
      <meta property="og:description" content={NOT_FOUND_SEO.description} />
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={NOT_FOUND_SEO.title} />
      <meta name="twitter:description" content={NOT_FOUND_SEO.description} />
    </Helmet>
  );
}
